var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.392 5.792A2.183 2.183 0 0 0 16.85 4.25C15.483 3.875 10 3.875 10 3.875s-5.475 0-6.85.358c-.733.2-1.342.809-1.542 1.559C1.25 7.158 1.25 10 1.25 10s0 2.858.358 4.208c.2.75.792 1.342 1.542 1.542 1.383.375 6.85.375 6.85.375s5.475 0 6.85-.358c.75-.2 1.342-.792 1.542-1.542.358-1.367.358-4.208.358-4.208s.017-2.85-.358-4.225ZM8.258 12.625v-5.25L12.817 10l-4.559 2.625Z",
    fill: "red"
  })));
};
export default SvgYoutube;